var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMessageCircleFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#2F7AFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.5556C22.003 14.7288 21.7289 15.8861 21.2 16.9334C20.5728 18.1883 19.6086 19.2437 18.4154 19.9816C17.2223 20.7195 15.8473 21.1105 14.4444 21.1112C13.2712 21.1141 12.1139 20.8401 11.0667 20.3112L6 22L7.68889 16.9334C7.15993 15.8861 6.88583 14.7288 6.88889 13.5556C6.88943 12.1527 7.28054 10.7777 8.01841 9.58452C8.75629 8.39136 9.81178 7.4272 11.0667 6.80003C12.1139 6.27108 13.2712 5.99696 14.4444 6.00003H14.8889C16.7416 6.10224 18.4916 6.88425 19.8037 8.19635C21.1157 9.50843 21.8977 11.2584 22 13.1111V13.5556Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessageCircleFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/message-circle-filled.f1f4ff59.svg";
export { ForwardRef as ReactComponent };